import React from 'react';

const Signing = props => (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    {/* Generator: Sketch 51.1 (57501) - http://www.bohemiancoding.com/sketch */}
    <title>Signing decorative icon</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <circle id="path-1" cx={36} cy={36} r={36} />
    </defs>
    <g
      id="School-Onboarding"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Payment---by-credit-card"
        transform="translate(-150.000000, -289.000000)"
      >
        <g
          id="Signing-decorative-icon"
          transform="translate(150.000000, 289.000000)"
        >
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1" />
          </mask>
          <use id="Mask" fill="#DFE1E7" xlinkHref="#path-1" />
          <g id="Group-6" mask="url(#mask-2)">
            <g transform="translate(17.052632, 15.157895)">
              <rect
                id="Rectangle"
                fill="#47506B"
                x="2.58947368"
                y={0}
                width="34.9578947"
                height="38.0990998"
                rx={1}
              />
              <rect
                id="Rectangle"
                fill="#FFFFFF"
                x={0}
                y={3}
                width="34.9578947"
                height="38.0990998"
                rx={1}
              />
              <g
                id="Group-7"
                strokeWidth={1}
                fill="none"
                transform="translate(5.000000, 9.000000)"
              >
                <rect
                  id="Rectangle-6"
                  fill="#9EA3B7"
                  x="0.178947368"
                  y="0.88978996"
                  width="25.2233912"
                  height="1.31700592"
                  rx="0.65850296"
                />
                <rect
                  id="Rectangle-6"
                  fill="#9EA3B7"
                  x="0.178947368"
                  y="5.96966994"
                  width="25.2233912"
                  height="1.31700592"
                  rx="0.65850296"
                />
                <rect
                  id="Rectangle-6"
                  fill="#9EA3B7"
                  x="0.178947368"
                  y="11.0495499"
                  width="11.223391"
                  height="1.31700592"
                  rx="0.65850296"
                />
                <rect
                  id="Rectangle-6"
                  fill="#9EA3B7"
                  x="0.178947368"
                  y="15.88979"
                  width="14.223391"
                  height="1.31700592"
                  rx="0.65850296"
                />
                <rect
                  id="Rectangle-6"
                  fill="#9EA3B7"
                  x="0.178947368"
                  y="19.9696699"
                  width="11.223391"
                  height="1.31700592"
                  rx="0.65850296"
                />
                <rect
                  id="Rectangle-6"
                  fill="#9EA3B7"
                  x="0.178947368"
                  y="23.9696699"
                  width="17.223391"
                  height="1.31700592"
                  rx="0.65850296"
                />
              </g>
            </g>
          </g>
          <g id="Group" mask="url(#mask-2)">
            <g transform="translate(49.004234, 45.886413) rotate(-44.000000) translate(-49.004234, -45.886413) translate(45.504234, 30.386413)">
              <path
                d="M2.23451677,1.68860353 L3.30508631,1.68860353 C3.49447234,1.68860353 3.66760389,1.79560472 3.7522999,1.96499673 L4.94090343,4.34220379 C5.06439805,4.58919304 4.96428588,4.88952956 4.71729663,5.01302418 C4.64786892,5.04773804 4.57131238,5.06581059 4.49368984,5.06581059 L1.04591324,5.06581059 C0.769770862,5.06581059 0.545913237,4.84195296 0.545913237,4.56581059 C0.545913237,4.48818804 0.563985783,4.41163151 0.598699641,4.34220379 L1.78730317,1.96499673 C1.87199918,1.79560472 2.04513074,1.68860353 2.23451677,1.68860353 Z"
                id="Rectangle-7"
                fill="#9EA3B7"
              />
              <rect
                id="Rectangle-4"
                fill="#576183"
                x="0.236896242"
                y="3.37720706"
                width="5.06581059"
                height="27.0176565"
                rx={2}
              />
              <polygon
                id="Triangle"
                fill="#47506B"
                points="2.76980154 0 3.6141033 1.68860353 1.92549977 1.68860353"
              />
              <rect
                id="Rectangle-5"
                fill="#9EA3B7"
                x="4.82719944"
                y="12.8261788"
                width="1.68860353"
                height="11.8202247"
                rx="0.5"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Signing;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/Signing.svg.jsx